import React from "react";

import BaseLayout from "./BaseLayout";

interface DefaultLayoutProps {
  children: React.ReactNode;
  allowEmptyQuery?: boolean;
  updateUrlWithSearchParams?: boolean;
}

/**
 * Renders navigation and places children in remaining space.
 *
 * No layout decisions are made for children——they must take full control
 * of their styling
 */
const DefaultLayout: React.FC<DefaultLayoutProps> = ({
  allowEmptyQuery = false,
  updateUrlWithSearchParams = false,
  children,
}) => (
  <BaseLayout
    allowEmptyQuery={allowEmptyQuery}
    updateUrlWithSearchParams={updateUrlWithSearchParams}
  >
    {children}
  </BaseLayout>
);

export default DefaultLayout;
